"use strict";

(function () {

	/*
	 * add focus class to all siblings when input is focused
	 */
	let input = document.querySelector(".q-search__input");

	if (input) {

		input.addEventListener("focus", function () {

			input.parentNode.childNodes.forEach(node => {

				if (node.nodeType === Node.ELEMENT_NODE) {
					node.classList.add("focus");
				}

			});

		});

		input.addEventListener("blur", function () {

			input.parentNode.childNodes.forEach(node => {

				if (node.nodeType === Node.ELEMENT_NODE) {
					node.classList.remove("focus");
				}

			});

		});

	}


	/*
	 * reset input when reset button is clicked
	 */
	let button = document.querySelector(".q-search__close");

	if (button) {

		button.addEventListener("click", function () {

			input.value = "";
			input.focus();

		});

	}

}());

// expand / collapse document sections

var documentLink = document.querySelectorAll(".q-document-top");
var currentUrl = window.location.href;

Array.prototype.forEach.call(documentLink, function(el){
	el.addEventListener("click", function(event){

		var targetId = event.target.id;
		if(location.hash){
			location.replace("#" + targetId);
		}
		else{
			location.replace(currentUrl + "#" + targetId);
		}	
	
		el.classList.toggle("minus");
		el.nextElementSibling.classList.toggle("show");
	});
});

// Get the part of the URL after the "#" symbol
var containsHash = currentUrl.indexOf("#") == -1 ? false : true;
if (containsHash) {
	var hashId = currentUrl.substring(currentUrl.indexOf("#") + 1);
	var hashEl = document.getElementById(hashId);
	if(hashEl !== null) {
		hashEl.click();
	}
}

// Listen for changes to the URL hash
window.addEventListener("hashchange", function() {

	var elWithMinus = document.querySelectorAll(".minus");
	elWithMinus.forEach(element => element.classList.remove('minus'));

	var elWithshow = document.querySelectorAll(".show");
	elWithshow.forEach(element => element.classList.remove('show'));

	// Get the element corresponding to the current hash
	var selectedEl = document.getElementById(location.hash.substring(1));
	if(selectedEl !== null) {
		selectedEl.click();
	}
  });
  	
	
	
